var Chart = (function () {
  

  var $packages;

  function init() {
    attachClick();
    layout();
  }

  function attachClick() {
    $packages = $('.acr-chart .package');
    $packages.on('click', clickHandler);
    $packages.find('.acr-cta-text').on('click', readMoreHandler);
  }

  function clickHandler() {
    var $this = $(this);
    var relatedPackages = $this.data('relatedPackages');

    $('.acr-chart .package').removeClass('active related');

    if (relatedPackages) {
      relatedPackages = relatedPackages.split(',');

      $.each(relatedPackages, function (i, id) {
        $('#' + id).addClass('related');
      });
    }

    $this.addClass('active');
  }

  function readMoreHandler(e) {
    e.preventDefault();

    var id = e.currentTarget.href.split('#')[1];
    var headerHeight = $('.acr-header').innerHeight();

    $('html, body').animate({
      scrollTop: $('#' + id).offset().top - headerHeight,
    }, 1000);
  }

  function layout() {
    $('.acr-chart').each(function (i, container) {
      var $container = $(container);
      var numPackages = 0;
      var $containerDiv = $('<div class="package-container"></div>');
      var pkgs = $container.find('.package');
      var pkgDivs = [];
      var limit;

      // Each row should have between 3 and 5 packages
      if (pkgs.length <= 5) {
        limit = pkgs.length;
      } else if (pkgs.length > 5 && pkgs.length <= 8) {
        limit = pkgs.length - 3;
      } else {
        limit = 5;
      }

      while (pkgs.length > 0) {
        var pkg = pkgs.splice(0, 1);
        numPackages += 1;

        $containerDiv.append(pkg);

        if (numPackages === limit) {
          pkgDivs.push($containerDiv);
          numPackages = 0;
          $containerDiv = $('<div class="package-container"></div>');
        }
      }

      if (!$containerDiv.is(':empty')) {
        pkgDivs.push($containerDiv);
      }

      pkgDivs.reverse();

      for (var j = 0; j < pkgDivs.length; j++) {
        pkgDivs[j].prependTo($container);
      }
    });
  }

  return {
    init: init,
  };
}());
